import { NotificationCard } from '../../components/Card';
import { Button, Center, Flex, Icon, Text } from '@chakra-ui/react';
import { useMarkAsReadMutation } from '@/store/query/notification';
import { NotificationLink } from '../../components/NotificationLink';
import { NotificationTime } from '../../components/Time';
import {
  RequisitionDetailsSection,
  RequisitionDetailsList,
} from '../requisition-notifications/components';
import { LayersThree02 } from '@kula-ai/icons/dual-tone/LayersThree02';
import { useSurveyNotificationData } from './utils/useSurveyNotificationData';
import { getNPSConfig } from '@/pages/settings/ats/survey/helpers/commonHelpers';

const SurveySubmitted = ({ notification = {}, onClose = () => {} }) => {
  const [markAsRead] = useMarkAsReadMutation();
  const { survey, candidate, job } = useSurveyNotificationData(notification);

  // Format NPS score display
  const formatNPS = () => {
    if (survey.npsScore === null || survey.npsScore === undefined) return null;
    const maxValue = 10;
    const npsConfig = getNPSConfig(survey.npsScore);
    return `${survey.npsScore}/${maxValue} - ${npsConfig.label}`;
  };

  // Format filled by with participant type
  const formatFilledBy = () => {
    if (!candidate.name) return null;
    const typeLabel = survey.participantType || 'Candidate';
    return `${candidate.name} (${typeLabel})`;
  };

  const detailsData = [
    { label: 'Filled by', value: formatFilledBy() },
    { label: 'Survey', value: survey.name },
    { label: 'Sent by', value: survey.sentBy?.name },
    { label: 'Job', value: job.name },
    { label: 'NPS', value: formatNPS() },
  ].filter((item) => item.value);

  const handleViewSubmission = () => {
    if (survey.submission_link || (survey.surveyId && survey.submissionId)) {
      markAsRead({ id: notification?.id });
      if (survey.submission_link) {
        window.open(survey.submission_link, '_self');
      } else if (survey.surveyId && survey.submissionId) {
        // Navigate to survey submission view
        window.open(
          `/dashboard?survey_id=${survey.surveyId}&submission_id=${survey.submissionId}`,
          '_self'
        );
      }
      onClose();
    }
  };

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="34px" h="34px" borderRadius="sm" bg="primary-100">
        <Icon as={LayersThree02} color="primary-500" width="16px" />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start" flex="1">
        <Text>
          {survey.name && (
            <Text as="span" size="sm-semi-bold">
              {survey.name}
            </Text>
          )}
          <Text as="span" fontSize="sm">
            {' '}
            survey has been filled by{' '}
          </Text>
          {candidate.name && (
            <Text as="span" size="sm-semi-bold">
              <NotificationLink
                to={candidate.url || `/candidates/${candidate.id}`}
                label={candidate.name}
                onClose={onClose}
                notification={notification}
              />
            </Text>
          )}
        </Text>

        <RequisitionDetailsSection title="Details">
          <RequisitionDetailsList data={detailsData} />
        </RequisitionDetailsSection>

        <NotificationTime notification={notification} />
        {(survey.url || (survey.surveyId && survey.submissionId)) && (
          <Button
            w="fit-content"
            variant="ats-primary"
            borderRadius="8px"
            onClick={handleViewSubmission}
            maxH="34px"
            data-test-id="view-submission-button"
          >
            View submission
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

export const SurveySubmittedNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <SurveySubmitted notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
